import { useGSAP } from "@gsap/react";
import { useLocation } from "@reach/router";
import gsap from "gsap";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { menuSections, minDeliveryProductPrice } from "../../../shared/data";
import { SectionKey } from "../../../shared/data/categories.model";
import { classNames, scrollToElement } from "../../../shared/utils/utils";
import { NewMenuSection } from "../new-menu-section";
import * as styles from "./new-menu.module.scss";

gsap.registerPlugin();

export const NewMenu = () => {
  const [selectedSection, setSelectedSection] = useState<SectionKey>(
    SectionKey.SUSHI
  );

  const containerRef = useRef<HTMLDivElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);

  const location = useLocation();

  const { t } = useTranslation();

  // useGSAP(
  //   () => {
  //     if (bodyRef.current) {
  //       gsap.fromTo(
  //         bodyRef.current,
  //         { autoAlpha: 0, y: 20 },
  //         { autoAlpha: 1, y: 0, duration: 0.3 }
  //       );
  //     }
  //   },
  //   { dependencies: [selectedSection], scope: bodyRef } // re-run when section changes
  // );

  useEffect(() => {
    const hash = location.hash;

    if (!hash) {
      return;
    }

    switch (hash) {
      case "#drinks":
        setSelectedSection(SectionKey.DRINKS);
        break;
      case "#sushi":
        setSelectedSection(SectionKey.SUSHI);
        break;
      case "#appetizers":
        setSelectedSection(SectionKey.APPETIZERS);
        break;
      case "#sets":
        setSelectedSection(SectionKey.SETS);
        break;
      case "#restaurant":
        setSelectedSection(SectionKey.RESTAURANT);
        break;
      case "#new-year-sets":
        setSelectedSection(SectionKey.SETS_SPECIAL);
        break;
      default:
        break;
    }

    if (hash) {
      scrollToMenu();
    }
  }, [location, setSelectedSection]);

  const scrollToMenu = (time: number = 1200) => {
    if (!containerRef.current) return;

    scrollToElement(containerRef.current, time, -80);
  };

  return (
    <section
      data-scroll-follow
      ref={containerRef}
      className={styles.sectionMenu}
    >
      <div className={styles.sectionMenu__wrapp}>
        <div
          className={classNames(
            styles,
            styles.minPriceInfo,
            styles.minPriceInfoMobile
          )}
        >
          {t("common.min_order", {
            amount: minDeliveryProductPrice,
          })}
        </div>
        <div className={styles.menuTabs}>
          {/* <div className={styles.tabs_border}></div> */}
          <div className={styles.tab__body} ref={bodyRef}>
            <NewMenuSection sectionKey={selectedSection} />
          </div>

          <div className={styles.tab__header}>
            <ul className={styles.tab__headerChapter}>
              {menuSections.map((tab) => (
                <li
                  key={tab.id}
                  className={`${styles.tab__chapter} ${
                    selectedSection === tab.id ? styles.active : ""
                  }`}
                  onClick={() => {
                    scrollToMenu(0);
                    // setSelectedSection(tab.id);
                    setTimeout(() => {
                      setSelectedSection(tab.id);
                    }, 0);
                  }}
                >
                  <div className={styles.tab__chapterIconWrapper}>
                    <img
                      className={styles.tab__chapterIcon}
                      src={tab.icon}
                      alt={tab.nameKey}
                    />
                  </div>
                  <span className={styles.tab__chapterText}>
                    {t(tab.nameKey)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
